import { numSampleFiles } from './constants';

let debug = true;

// This is basically like "ducks"

export const sessions = {
    first: 'A',
    second: 'B',
};

export const userResponses = {
    yes: 'Y',
    no: 'N',
    unclear: 'unclear',
};

export const modes = {
    orbHidden: 'orb-hidden',
    active: 'system-active',
    inactive: 'system-inactive',
    userSpeaking: 'user-speaking',
    userAudioPlayback: 'user-audio-playback',
    buttonsOnly: 'buttons-only',
};

export const stateNames = {
    tutorial: 'statename/tutorial',
    home: 'home',
    introPrompt: 'introPrompt',
    userReplyOne: 'userReplyOne',
    promptMore: 'promptMore',
    userReplyTwo: 'userReplyTwo',
    promptMoreTwo: 'promptMoreTwo',
    userReplyThree: 'userReplyThree',
    proposeLoopback: 'proposeLoopback',
    userYesNo: 'userYesNo',
    userYesNo2: 'userYesNo2',
    userYesNo3: 'userYesNo3',
    toContinueLoop: 'toContinueLoop',
    sorryDidntGetThat: 'sorryDidntGetThat',
    pleaseAnswerYesOrNo: 'pleaseAnswerYesOrNo',
    toPlayback: 'toPlayback',
    playBack: 'playBack',
    thankYouForSharing: 'thankYouForSharing',
};

export const stateModes = {
    tutorial: modes.orbHidden,
    home: modes.inactive,
    introPrompt: modes.active,
    userReplyOne: modes.userSpeaking,
    promptMore: modes.active,
    userReplyTwo: modes.userSpeaking,
    promptMoreTwo: modes.active,
    userReplyThree: modes.userSpeaking,
    proposeLoopback: modes.active,
    userYesNo: modes.userSpeaking,
    userYesNo2: modes.userSpeaking,
    userYesNo3: modes.userSpeaking,
    toContinueLoop: modes.active,
    sorryDidntGetThat: modes.active,
    pleaseAnswerYesOrNo: modes.active,
    toPlayback: modes.active,
    playBack: modes.userAudioPlayback,
    thankYouForSharing: modes.active,
};

export const actionTypes = {
    nextPage: 'nextPage',
    setPause: 'setPause',
    stop: 'stop',
    addAudio: 'addAudio',
    addIntBuffer: 'addIntBuffer',
    openTutorial: 'openTutorial',
    setSilenceSeconds: 'setSilenceSeconds',
    setCurrentlyPlayingAudio: 'setCurrentlyPlayingAudio',
    setTranscribingAudio: 'setTranscribingAudio',
    setManualContinueButton: 'setManualContinueButton',
    registerYesNo: 'registerYesNo',
};

// Initial state
// localStorage.setItem('myData', data);
const hasSeenTutorial = localStorage.getItem('hasSeenTutorial');
// const hasSeenTutorial = false;
export const initialState = {
    stateName: hasSeenTutorial ? stateNames.home : stateNames.tutorial,
    mode: hasSeenTutorial ? modes.inactive : modes.orbHidden,
    session: sessions.first,
    paused: true,
    showingButtons: false,
    userRecordedIntBuffer: [],
    showingMenu: false,
    silenceSeconds: 3.0,
    randomTrackNumber: 1,
    currentlyPlayingAudio: null,
    transcribingAudio: false,
    manualContinueButton: true,
    temporarilyHideContinueButton: false,
    ignoreSpeechToText: false,
};

// Params: Accumulator and value
// This is essentially a 'state machine', takes old state and reduces down to new state based on action
// Action is an object that has "type", "payload"
export const reducer = (oldState, action) => {
    const currentSession = oldState.session;

    if (action.type === actionTypes.setPause) {
        console.log(oldState.paused ? 'un-pausing!' : 'pausing');

        if (action.payload === true) {
            console.log('Pausing true');
            return {
                ...oldState,
                paused: true,
                temporarilyHideContinueButton: !oldState.temporarilyHideContinueButton,
            };
        }

        return {
            ...oldState,
            paused: !oldState.paused,
            temporarilyHideContinueButton: !oldState.temporarilyHideContinueButton,
        };
    }

    if (action.type === actionTypes.toggleMenu) {
        return {
            ...oldState,
            showingMenu: !oldState.showingMenu,
        };
    }

    if (action.type === actionTypes.openTutorial) {
        return {
            ...oldState,
            stateName: stateNames.tutorial,
        };
    }

    if (action.type === actionTypes.setCurrentlyPlayingAudio) {
        const newAudio = action.payload;
        // console.log('new audio!!', newAudio);
        return {
            ...oldState,
            currentlyPlayingAudio: newAudio,
        };
    }

    if (action.type === actionTypes.setSilenceSeconds) {
        const newSilenceSeconds = action.payload;
        // console.log('going to set new silence seconds: ', newSilenceSeconds);
        return {
            ...oldState,
            silenceSeconds: newSilenceSeconds,
        };
    }

    if (action.type === actionTypes.setTranscribingAudio) {
        return {
            ...oldState,
            transcribingAudio: action.payload,
        };
    }

    if (action.type === actionTypes.setManualContinueButton) {
        return {
            ...oldState,
            manualContinueButton: action.payload,
        };
    }

    // On stop, return to home screen
    if (action.type === actionTypes.stop) {
        return initialState;
    }

    if (action.type === actionTypes.addIntBuffer) {
        // Concat new int buffer to the giant int buffer in the sky
        const newIntBuffer = action.payload;
        return {
            ...oldState,
            userRecordedIntBuffer: [
                ...oldState.userRecordedIntBuffer,
                ...newIntBuffer,
            ],
        };
    }

    // Check we're not getting a double action
    if (action.payload) {
        if (action.payload.response) {
            if (action.payload.currentState) {
                console.log(
                    'action.payload.currentState',
                    action.payload.currentState
                );
                console.log('oldstate.statename', oldState.stateName);
            }
        }
    }

    // // On stop, return to home screen
    // if (action.type === actionTypes.registerManualYesNo) {

    // }

    // Else, the action type is "nextPage"
    // Action.payload should exist if needed
    let nextStateName;

    switch (oldState.stateName) {
        case stateNames.tutorial:
            nextStateName = stateNames.home;
            if (debug) console.log(`${oldState.stateName} -> ${nextStateName}`);
            return {
                ...oldState,
                stateName: nextStateName,
                session: sessions.first,
                mode: stateModes[nextStateName],
            };
        // Home screen (press orb to start)
        case stateNames.home:
            nextStateName = stateNames.introPrompt;
            if (debug) console.log(`${oldState.stateName} -> ${nextStateName}`);
            return {
                ...oldState,
                stateName: nextStateName,
                mode: stateModes[nextStateName],
                randomTrackNumber: getRandomTrackNumber(
                    nextStateName,
                    oldState.session
                ),
                paused: false,
            };
        // SYSTEM: "Tell me about your day"
        // Reset all audio URLs here
        // Also need to set currentlyPlayingAudio to null
        // or it inexplicably remembers it
        case stateNames.introPrompt:
            nextStateName = stateNames.userReplyOne;
            if (debug) console.log(`${oldState.stateName} -> ${nextStateName}`);
            return {
                ...oldState,
                stateName: nextStateName,
                mode: stateModes[nextStateName],
                userRecordedIntBuffer: [],
                currentlyPlayingAudio: null,
                ignoreSpeechToText: false,
                temporarilyHideContinueButton: false,
                transcribingAudio: false,
            };
        // USER: "I had a crappy day"
        case stateNames.userReplyOne:
            nextStateName = stateNames.promptMore;
            if (debug) console.log(`${oldState.stateName} -> ${nextStateName}`);
            return {
                ...oldState,
                stateName: nextStateName,
                mode: stateModes[nextStateName],
                randomTrackNumber: getRandomTrackNumber(
                    nextStateName,
                    oldState.session
                ),
                manualContinueButton: true,
                temporarilyHideContinueButton: false,
            };
        // SYSTEM: "Tell me how you feel"
        case stateNames.promptMore:
            nextStateName = stateNames.userReplyTwo;
            if (debug) console.log(`${oldState.stateName} -> ${nextStateName}`);
            return {
                ...oldState,
                stateName: nextStateName,
                mode: stateModes[nextStateName],
            };
            
        // USER: "I feel really bad"
        case stateNames.userReplyTwo:
            nextStateName = stateNames.promptMoreTwo;
            if (debug) console.log(`${oldState.stateName} -> ${nextStateName}`);
            return {
                ...oldState,
                stateName: nextStateName,
                mode: stateModes[nextStateName],
                randomTrackNumber: getRandomTrackNumber(
                    nextStateName,
                    oldState.session
                ),
                manualContinueButton: true,
                temporarilyHideContinueButton: false,
            };
        // SYSTEM: "Tell me how you feel"
        case stateNames.promptMoreTwo:
            nextStateName = stateNames.userReplyThree;
            if (debug) console.log(`${oldState.stateName} -> ${nextStateName}`);
            return {
                ...oldState,
                stateName: nextStateName,
                mode: stateModes[nextStateName],
            };
        // USER: "I feel really bad"
        case stateNames.userReplyThree:
            nextStateName = stateNames.proposeLoopback;
            if (debug) console.log(`${oldState.stateName} -> ${nextStateName}`);
            return {
                ...oldState,
                stateName: nextStateName,
                mode: stateModes[nextStateName],
                randomTrackNumber: getRandomTrackNumber(
                    nextStateName,
                    oldState.session
                ),
                manualContinueButton: true,
                temporarilyHideContinueButton: false,
            };
        // SYSTEM: "Is there anything else you'd like to add?"
        case stateNames.proposeLoopback:
            nextStateName = stateNames.userYesNo;
            if (debug) console.log(`${oldState.stateName} -> ${nextStateName}`);
            return {
                ...oldState,
                stateName: nextStateName,
                displayYesNoButtons: true,
                temporarilyHideContinueButton: true,
                mode: stateModes[nextStateName],
                // hides continue button and shows yes/no instead*
                displayYesNoButtons: true,
                temporarilyHideContinueButton: true,
            };
        // USER: "Yes" / "No" / *indistinct mumbling*
        case stateNames.userYesNo:
            console.log('action!', action);

            if (action.payload.response === userResponses.no) {
                // SYSTEM: "OK, playing back now"
                nextStateName = stateNames.toPlayback;
                if (debug)
                    console.log(`${oldState.stateName} -> ${nextStateName}`);
                return {
                    ...oldState,
                    stateName: nextStateName,
                    displayYesNoButtons: false,
                    mode: stateModes[nextStateName],
                    randomTrackNumber: getRandomTrackNumber(
                        nextStateName,
                        oldState.session
                    ),
                    paused: false,
                    ignoreSpeechToText: action.payload.ignoreSpeechToText
                        ? true
                        : false,
                };
            } else if (action.payload.response === userResponses.yes) {
                // SYSTEM: "OK, tell me more"
                nextStateName = stateNames.toContinueLoop;
                if (debug)
                    console.log(`${oldState.stateName} -> ${nextStateName}`);
                return {
                    ...oldState,
                    stateName: nextStateName,
                    mode: stateModes[nextStateName],
                    temporarilyHideContinueButton: false,
                    manualContinueButton: true,
                    randomTrackNumber: getRandomTrackNumber(
                        nextStateName,
                        oldState.session
                    ),
                    paused: false,
                    ignoreSpeechToText: action.payload.ignoreSpeechToText
                        ? true
                        : false,
                };
            } else {
                // SYSTEM: "Sorry, I didn't quite get that"
                nextStateName = stateNames.sorryDidntGetThat;
                if (debug)
                    console.log(`${oldState.stateName} -> ${nextStateName}`);
                return {
                    ...oldState,
                    stateName: nextStateName,
                    mode: stateModes[nextStateName],
                    randomTrackNumber: getRandomTrackNumber(
                        nextStateName,
                        oldState.session
                    ),
                    paused: false,
                };
            }
        case stateNames.userYesNo2:
            if (action.payload.response === userResponses.no) {
                // SYSTEM: "OK, playing back now"
                nextStateName = stateNames.toPlayback;
                if (debug)
                    console.log(`${oldState.stateName} -> ${nextStateName}`);
                return {
                    ...oldState,
                    stateName: nextStateName,
                    displayYesNoButtons: false,
                    mode: stateModes[nextStateName],
                    randomTrackNumber: getRandomTrackNumber(
                        nextStateName,
                        oldState.session
                    ),
                    paused: false,
                    ignoreSpeechToText: action.payload.ignoreSpeechToText
                        ? true
                        : false,
                };
            } else if (action.payload.response === userResponses.yes) {
                // SYSTEM: "OK, tell me more"
                nextStateName = stateNames.toContinueLoop;
                if (debug)
                    console.log(`${oldState.stateName} -> ${nextStateName}`);
                return {
                    ...oldState,
                    stateName: nextStateName,
                    mode: stateModes[nextStateName],
                    randomTrackNumber: getRandomTrackNumber(
                        nextStateName,
                        oldState.session
                    ),
                    paused: false,
                    ignoreSpeechToText: action.payload.ignoreSpeechToText
                        ? true
                        : false,
                };
            } else {
                // SYSTEM: "Sorry, I didn't quite get that"
                nextStateName = stateNames.pleaseAnswerYesOrNo;
                if (debug)
                    console.log(`${oldState.stateName} -> ${nextStateName}`);
                return {
                    ...oldState,
                    stateName: nextStateName,
                    mode: stateModes[nextStateName],
                    randomTrackNumber: getRandomTrackNumber(
                        nextStateName,
                        oldState.session
                    ),
                    paused: false,
                };
            }
        case stateNames.userYesNo3:
            if (action.payload.response === userResponses.no) {
                // SYSTEM: "OK, playing back now"
                nextStateName = stateNames.toPlayback;
                if (debug)
                    console.log(`${oldState.stateName} -> ${nextStateName}`);
                return {
                    ...oldState,
                    stateName: nextStateName,
                    displayYesNoButtons: false,
                    mode: stateModes[nextStateName],
                    randomTrackNumber: getRandomTrackNumber(
                        nextStateName,
                        oldState.session
                    ),
                    paused: false,
                    temporarilyHideContinueButton: false,
                    ignoreSpeechToText: action.payload.ignoreSpeechToText
                        ? true
                        : false,
                };
            } else if (action.payload.response === userResponses.yes) {
                // SYSTEM: "OK, tell me more"
                nextStateName = stateNames.toContinueLoop;
                if (debug)
                    console.log(`${oldState.stateName} -> ${nextStateName}`);
                return {
                    ...oldState,
                    stateName: nextStateName,
                    mode: stateModes[nextStateName],
                    randomTrackNumber: getRandomTrackNumber(
                        nextStateName,
                        oldState.session
                    ),
                    paused: false,
                    temporarilyHideContinueButton: false,
                    ignoreSpeechToText: action.payload.ignoreSpeechToText
                        ? true
                        : false,
                };
            } else if (action.payload.response === userResponses.unclear) {
                if (debug)
                    console.log(
                        `${oldState.stateName} -> ${oldState.stateName}`
                    );
                // Back to the same state, but this time showing the buttons
                return {
                    ...oldState,
                    paused: false,
                    displayYesNoButtons: true,
                    temporarilyHideContinueButton: true,
                };
            } else {
                console.log("Shouldn't get here");
                break;
            }
        // SYSTEM: "Sorry, I didn't quite get that"
        case stateNames.sorryDidntGetThat:
            nextStateName = stateNames.userYesNo2;
            if (debug) console.log(`${oldState.stateName} -> ${nextStateName}`);
            return {
                ...oldState,
                stateName: nextStateName,
                mode: stateModes[nextStateName],
            };
        case stateNames.pleaseAnswerYesOrNo:
            nextStateName = stateNames.userYesNo3;
            if (debug) console.log(`${oldState.stateName} -> ${nextStateName}`);
            // Don't show the buttons at first, only if the request fails
            return {
                ...oldState,
                stateName: nextStateName,
                displayYesNoButtons: false,
                mode: stateModes[nextStateName],
                paused: false,
            };
        // SYSTEM: "OK, playing back now"
        case stateNames.toPlayback:
            nextStateName = stateNames.playBack;
            if (debug) console.log(`${oldState.stateName} -> ${nextStateName}`);
            return {
                ...oldState,
                stateName: nextStateName,
                mode: stateModes[nextStateName],
                transcribingAudio: false,
            };
        // SYSTEM: "OK, tell me more"
        case stateNames.toContinueLoop:
            nextStateName = stateNames.userReplyTwo;
            if (debug) console.log(`${oldState.stateName} -> ${nextStateName}`);
            return {
                ...oldState,
                stateName: nextStateName,
                mode: stateModes[nextStateName],
                displayYesNoButtons: false,
            };
        // SYSTEM: (playing back) *I had a really crappy day.....*
        case stateNames.playBack:
            nextStateName =
                currentSession === sessions.first
                    ? stateNames.introPrompt
                    : stateNames.thankYouForSharing;
            if (debug) console.log(`${oldState.stateName} -> ${nextStateName}`);
            return {
                ...oldState,
                stateName: nextStateName,
                session: sessions.second,
                mode: stateModes[nextStateName],
                randomTrackNumber: getRandomTrackNumber(
                    nextStateName,
                    sessions.second
                ),
                transcribingAudio: false,
            };
        // SYSTEM: "Thank you for sharing" -> Then back to start
        case stateNames.thankYouForSharing:
            if (debug) console.log(`${oldState.stateName} -> BACK TO START`);
            return initialState;

        default:
            return oldState;
    }
};

function getRandomTrackNumber(stateName, session) {
    const numTracksForSession = numSampleFiles[session + stateName];
    let randomTrack = Math.floor(Math.random() * numTracksForSession + 1);
    // This shouldn't happen, but as a fallback...
    if (isNaN(randomTrack)) {
        console.log(
            `Chose track: ${randomTrack} for ${stateName} in session ${session}. 
            numTracksForSession was ${numTracksForSession}`
        );
        randomTrack = 1;
    }
    return randomTrack;
}
